(function() {
  function initArtworkForm() {
    var order = new URLSearchParams(window.location.search).get('order');
    if (!order || order.length > 100) return;
    document.querySelectorAll('[data-artwork-upload-link]').forEach(function(link) {
      var url = new URL(link.href, window.location.origin);
      // A prefilled order number is only a convenience: the uploader verifies it.
      url.searchParams.set('order', order);
      link.href = url.href;
    });
  }

  function initDesignGallery() {
    var cards = document.querySelectorAll('.design-gallery__card');
    var selectedPanel = document.getElementById('design-selected');
    var selectedName = document.getElementById('design-selected-name');
    if (!cards.length) return;

    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        cards.forEach(function(c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');

        var name = card.dataset.designName || 'Selected design';
        if (selectedName) selectedName.textContent = name;
        if (selectedPanel) {
          selectedPanel.style.display = 'block';
          selectedPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  }

  function initDesignBuy() {
    var addBtn = document.getElementById('design-add-btn');
    var sizeSelect = document.getElementById('design-size');
    var selectedName = document.getElementById('design-selected-name');
    if (!addBtn || !sizeSelect) return;

    addBtn.addEventListener('click', function() {
      var opt = sizeSelect.options[sizeSelect.selectedIndex];
      var id = opt ? opt.value : null;
      if (!id) return;

      var design = selectedName ? selectedName.textContent : '';
      var sizeTitle = opt ? (opt.dataset.title || opt.textContent) : '';
      var original = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: id,
            quantity: 1,
            properties: {
              'Design': design,
              'Artwork': 'To be uploaded after payment'
            }
          }]
        })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('add failed');
        return fetch('/cart.js');
      })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        showCartToast(design + ' — ' + sizeTitle);
        addBtn.textContent = 'Added \u2713';
        setTimeout(function() {
          addBtn.textContent = original;
          addBtn.disabled = false;
        }, 1600);
      })
      .catch(function() {
        addBtn.textContent = original;
        addBtn.disabled = false;
        alert('Sorry, we could not add that to your basket. Please try again.');
      });
    });
  }

  function initDesignSlides() {
    var boxes = document.querySelectorAll('.design-gallery__image--slides');
    boxes.forEach(function(box) {
      var imgs = box.querySelectorAll('img');
      if (imgs.length < 2) return;
      var i = 0;
      imgs[0].classList.add('is-active');
      setInterval(function() {
        imgs[i].classList.remove('is-active');
        i = (i + 1) % imgs.length;
        imgs[i].classList.add('is-active');
      }, 3000);
    });
  }

  function initFaqAccordion() {
    var buttons = document.querySelectorAll('.faq__question');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.faq__item');
        var isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.faq__item.is-open').forEach(function(openItem) {
          openItem.classList.remove('is-open');
        });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  function updateCartCount(count) {
    var els = document.querySelectorAll('[data-cart-count]');
    els.forEach(function(el) {
      el.textContent = count;
      if (count > 0) {
        el.classList.remove('is-empty');
      } else {
        el.classList.add('is-empty');
      }
    });
  }

  function showCartToast(title) {
    var toast = document.getElementById('cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'cart-toast';
      toast.className = 'cart-toast';
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<span class="cart-toast__check">&#10003;</span>' +
      '<span class="cart-toast__text">Added to basket' + (title ? ': ' + title : '') + '</span>' +
      '<a href="/cart" class="cart-toast__link">View basket</a>';
    toast.classList.add('is-visible');
    clearTimeout(showCartToast._timer);
    showCartToast._timer = setTimeout(function() {
      toast.classList.remove('is-visible');
    }, 4000);
  }

  function initAddToCart() {
    var buttons = document.querySelectorAll('.js-add-to-cart');
    if (!buttons.length) return;

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id = btn.dataset.variantId;
        if (!id) return;

        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: id,
              quantity: 1,
              properties: { 'Artwork': 'To be uploaded after payment' }
            }]
          })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('add failed');
          return fetch('/cart.js');
        })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          updateCartCount(cart.item_count);
          showCartToast(btn.dataset.variantTitle);
          btn.textContent = 'Added \u2713';
          setTimeout(function() {
            btn.textContent = original;
            btn.disabled = false;
          }, 1600);
        })
        .catch(function() {
          btn.textContent = original;
          btn.disabled = false;
          alert('Sorry, we could not add that to your basket. Please try again.');
        });
      });
    });
  }

  function initStickerBuilder() {
    var app = document.getElementById('sticker-builder-app');
    if (!app) return;

    var jsonEl = document.getElementById('StickerProductJson');
    var dataEl = document.getElementById('StickerProductData');
    if (!jsonEl || !dataEl) return;

    var variants = [];
    var productData = {};
    try {
      variants = JSON.parse(jsonEl.textContent);
      productData = JSON.parse(dataEl.textContent);
    } catch(e) {
      console.error('Failed to parse sticker product data');
      return;
    }

    var inputs = app.querySelectorAll('input[type="radio"]');
    var priceDisplay = document.getElementById('sb-price-display');
    var unitPriceDisplay = document.getElementById('sb-unit-price');
    var addBtn = document.getElementById('sb-add-btn');

    function updateState() {
      if (unitPriceDisplay) {
        unitPriceDisplay.hidden = true;
        unitPriceDisplay.textContent = '';
      }
      var size = app.querySelector('input[name="sb_size"]:checked');
      var shape = app.querySelector('input[name="sb_shape"]:checked');
      var qty = app.querySelector('input[name="sb_qty"]:checked');

      if (!size || !shape || !qty) {
        priceDisplay.textContent = '--';
        addBtn.disabled = true;
        addBtn.textContent = 'Select options to buy';
        return;
      }

      var selectedSize = size.value;
      var selectedShape = shape.value;
      var selectedQty = qty.value;

      var matchedVariant = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.option1 === selectedSize && v.option2 === selectedShape && v.option3 === selectedQty) {
          matchedVariant = v;
          break;
        }
      }

      if (matchedVariant) {
        var priceStr = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(matchedVariant.price / 100);
        priceDisplay.textContent = priceStr;
        if (unitPriceDisplay) {
          unitPriceDisplay.textContent = 'Approx. ' + new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(matchedVariant.price / 100 / Number(selectedQty)) + ' per sticker';
          unitPriceDisplay.hidden = false;
        }
        
        if (matchedVariant.available) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to basket';
          addBtn.dataset.variantId = matchedVariant.id;
          addBtn.dataset.variantTitle = productData.title + ' — ' + matchedVariant.title;
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold out';
          delete addBtn.dataset.variantId;
        }
      } else {
        priceDisplay.textContent = '--';
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        delete addBtn.dataset.variantId;
      }
    }

    inputs.forEach(function(input) {
      input.addEventListener('change', updateState);
    });
  }

  function init() {
    initArtworkForm();
    initDesignGallery();
    initDesignBuy();
    initDesignSlides();
    initFaqAccordion();
    initAddToCart();
    initStickerBuilder();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
